Object.defineProperty(exports, "__esModule", {
  value: true
});

var hrefRegex = /^$|^#$|^javascript:/;

function href(props, propName, componentName) {
  if (hrefRegex.test(props[propName])) {
    return new Error("Invalid prop `" + String(propName) + "` supplied to `" + String(componentName) + "`. Validation failed.");
  }
  return null;
}

href.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error("Invalid prop `" + String(propName) + "` was not specified in `" + String(componentName) + "`");
  }
  return href(props, propName, componentName);
};

exports["default"] = href;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/href.js
// module id = 123
// module chunks = 168707334958949